<template>
  <el-select
    v-model="dataValue"
    style="width: 100%;"
    placeholder="请选择证书模板"
    clearable=""
    @change="onChage">
    <el-option
      v-for="item in list"
      :key="item.id"
      :label="item.templateName"
      :value="item.id"></el-option>
  </el-select>
</template>
<script>
import Cert from '@/service/cert'
export default {
  name: 'CertTemplateSelect',
  props: {
    value: { type: [Number, String] }
  },
  data() {
    return { list: [] }
  },
  computed: {
    dataValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    onChage() {},
    getList() {
      Cert.getluxurycerttemplates({ pageNum: 1, pageSize: 100 })
        .then(res => {
          const { result, message, records } = res.data
          if (result === 0) {
            this.list = records.map(i => ({ id: i.id, templateName: i.templateName }))
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    }
  }
}
</script>
